import React, { useState, useEffect, useRef } from 'react';

interface ChartContainerProps {
  children: React.ReactNode;
  minHeight?: number;
}

export const ChartContainer: React.FC<ChartContainerProps> = ({ children, minHeight = 250 }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!containerRef.current) return;
    
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        if (width > 0 && height > 0) {
          setDimensions({ width, height });
        }
      }
    });
    
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div 
      ref={containerRef} 
      className="flex-1 relative w-full h-full" 
      style={{ minHeight: `${minHeight}px` }}
    >
      {dimensions.width > 0 && dimensions.height > 0 ? (
        children
      ) : (
        <div className="flex items-center justify-center h-full text-slate-400 text-xs">
          Initializing chart...
        </div>
      )}
    </div>
  );
};
